import axios from 'axios'
import NotificationModel from '@/services/Models/NotificationModel'
import UserModel from '@/services/Models/UserModel'
import ChallengeModel from '@/services/Models/ChallengeModel'

export default {
  getData() {
    return axios.get('/me/data')
      .then(response => (response.data))
  },

  getNotifications() {
    return axios.get('/me/notifications')
      .then(mapToNotifications)
  },

  clearNotifications() {
    return axios.post('/me/clear-notifications')
  },

  updateUser(data) {
    return axios.put('/me', data)
      .then(mapToUser)
  },

  linkToChallenge(challenge_id) {
    return axios.post('/me/challenges', { challenge_id })
      .then(mapToChallenge)
  },

  getOngoingChallenge() {
    return axios.get('/me/challenges', {
      params: {
        ongoing: true
      }
    })
    .then(response => {
      return response.data.length <= 0 ? null : ChallengeModel(response.data[0])
    })
  }
}

function mapToChallenge(response) {
  return ChallengeModel(response.data)
}

function mapToUser(response) {
  return UserModel(response.data)
}

function mapToNotifications(response) {
  response.data = response.data.map(NotificationModel)

  return response.data
}



// WEBPACK FOOTER //
// ./src/services/Api/UserApi.js